// AM dashboard: where a user lands, and who may look at whose dashboard. PURE.

export const AM_DASHBOARD_PATH = '/dashboard/am';
export const AM_FITNESS_ROLE = 'account_manager_fitness';

/** The page a signed-in user lands on at the root route and after sign-in. */
export function homePathFor(user: { jobRole?: string | null } | null | undefined): string {
  return user?.jobRole === AM_FITNESS_ROLE ? AM_DASHBOARD_PATH : '/';
}

/**
 * Whose book a request may read. `param` is the `?am=` value: absent / `mine` =
 * the requester's own; their own uid is the same thing; `all` and any OTHER uid
 * are ADMIN ONLY. Returns the scope or null when refused (the router answers 403).
 */
export function resolveAmDashboardScope(
  param: string | undefined,
  requester: { uid: string; role: 'admin' | 'staff' },
): { amUid: string | null } | null {
  if (!param || param === 'mine' || param === requester.uid) return { amUid: requester.uid };
  if (requester.role !== 'admin') return null;
  if (param === 'all') return { amUid: null };
  return { amUid: param };
}

/** "View all" on the asset gallery: the staff asset list, this AM's accounts, newest first (its default sort). */
export function viewAllAssetsHref(amUid: string | null): string {
  return amUid
    ? `/tools/portal-assets?view=all&manager=${encodeURIComponent(amUid)}`
    : '/tools/portal-assets?view=all';
}
